import ServiceCategoryPage from "../components/ServiceCategoryPage";
import doorWindowFitterService from "../data/services/doorWindowFitterService";

function DoorWindowFitter() {
  return <ServiceCategoryPage service={doorWindowFitterService} />;
}

export default DoorWindowFitter;